import { AxiosResponse } from "axios";
import api from "../apiService";

export const getBanksAPI = async ({ lang }: { lang: string }): Promise<any> =>
	new Promise(async (resolve, reject) => {
		try {
			const path = "/banks";
			const response: AxiosResponse = await api.get(path, { language: lang });
			resolve(response.data);
		} catch (err) {
			reject(err);
		}
	});
	
